import { Helmet } from "react-helmet";
import HealthStatus from "views/components/HealthStatus";
import ContainerHeader from "views/components/ContainerHeader";
import { DATASET_CREATION_PAGE } from "helpers/constants/pages";

import styles from "./style.module.scss";

function PageHeader() {
  return (
    <>
      <Helmet>
        <title>Dataset Creation</title>
      </Helmet>
      <div className={styles.headerContainer}>
        <ContainerHeader
          page={DATASET_CREATION_PAGE}
          dynamicPage={DATASET_CREATION_PAGE}
        />
        <HealthStatus />
      </div>
    </>
  );
}

export default PageHeader;
